import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { ToastContainer } from "react-toastify";

import { AuthContextProvider } from "./context/AuthContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <ToastContainer />
    <AuthContextProvider>
      <SubscriptionProvider>
        <App />
      </SubscriptionProvider>
    </AuthContextProvider>
  </ThemeProvider>
);
